import React, { useState } from "react";
import { Button } from "reactstrap";
import { Icon, Menu, MenuItem } from "@material-ui/core";
import RuleCard from "./rule_card";
import { SectionPanel } from "./common_controls";
import { classifyRule, buildEmptyCondition, buildEmptyCaptureMultiple, buildEmptyCaptureData } from "./config_model";

const RuleList = ({ rules, onChange, knownColumns }) => {
  const [addMenuAnchor, setAddMenuAnchor] = useState(null);

  const updateRule = (i, newRule) => onChange(rules.map((r, idx) => (idx === i ? newRule : r)));
  const removeRule = i => onChange(rules.filter((_, idx) => idx !== i));
  const moveRule = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= rules.length) return;
    const next = [...rules];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const addRule = builder => {
    onChange([...rules, classifyRule(builder())]);
    setAddMenuAnchor(null);
  };

  return (
    <SectionPanel title="Verification Rules">
      {!rules.length && <div className="small text-muted mb-2">No rules yet. Add one below, or switch to JSON View to paste an existing configuration.</div>}
      {rules.map((rule, i) => (
        <RuleCard
          key={rule.id}
          index={i}
          rule={rule}
          onChange={newRule => updateRule(i, newRule)}
          onRemove={() => removeRule(i)}
          onMoveUp={i > 0 ? () => moveRule(i, -1) : null}
          onMoveDown={i < rules.length - 1 ? () => moveRule(i, 1) : null}
          knownColumns={knownColumns}
        />
      ))}
      <Button size="sm" className="buttonred" onClick={e => setAddMenuAnchor(e.currentTarget)}>
        <Icon fontSize="small" className="align-middle">add</Icon> Add Rule
      </Button>
      <Menu anchorEl={addMenuAnchor} open={!!addMenuAnchor} onClose={() => setAddMenuAnchor(null)}>
        <MenuItem onClick={() => addRule(buildEmptyCondition)}>Condition → Update Rule</MenuItem>
        <MenuItem onClick={() => addRule(buildEmptyCaptureMultiple)}>Auto-capture repeat submissions</MenuItem>
        <MenuItem onClick={() => addRule(buildEmptyCaptureData)}>Auto-capture referral leads</MenuItem>
      </Menu>
    </SectionPanel>
  );
};

export default RuleList;
